// Asset Selector Widget - Dropdown for selecting trading assets
class AssetSelector {
    constructor(containerId) {
        this.containerId = containerId;
        this.container = null;
        this.selectedAsset = 'BTC';
        this.assets = [
            'BTC', 'ETH', 'SOL', 'AVAX', 'MATIC', 'DOT', 'LINK', 'UNI', 'AAVE', 'SUSHI'
        ];
        this.onAssetChange = null;
        
        this.init();
    }

    /**
     * Initialize the asset selector
     */
    init() {
        this.container = document.getElementById(this.containerId);
        if (!this.container) {
            console.error(`Asset selector container ${this.containerId} not found`);
            return;
        }

        this.render();
        this.setupEventListeners();
    }

    /**
     * Render the asset selector
     */
    render() {
        const options = this.assets.map(asset => 
            `<option value="${asset}" ${asset === this.selectedAsset ? 'selected' : ''}>${asset}</option>`
        ).join('');

        this.container.innerHTML = `
            <div class="asset-selector">
                <label for="asset-dropdown">Asset:</label>
                <select id="asset-dropdown" class="asset-dropdown">
                    ${options}
                </select>
                <div class="asset-price" id="asset-price">
                    <span class="price-label">Price:</span>
                    <span class="price-value" id="price-value">$--,---</span>
                </div>
            </div>
        `;
    }

    /**
     * Setup event listeners
     */
    setupEventListeners() {
        const dropdown = this.container.querySelector('#asset-dropdown');
        if (dropdown) {
            dropdown.addEventListener('change', (e) => {
                this.selectedAsset = e.target.value;
                this.updatePrice();
                
                if (this.onAssetChange) {
                    this.onAssetChange(this.selectedAsset);
                }
            });
        }

        // Update price initially
        this.updatePrice();
    }

    /**
     * Update price display for selected asset
     */
    async updatePrice() {
        const priceElement = this.container.querySelector('#asset-price');
        if (!priceElement) return;

        try {
            if (window.electronAPI) {
                const result = await window.electronAPI.invoke('hyperliquid:getAllMids');
                if (result.success && result.mids && result.mids[this.selectedAsset]) {
                    const price = parseFloat(result.mids[this.selectedAsset]);
                    priceElement.querySelector('#price-value').textContent = `$${price.toLocaleString()}`;
                } else {
                    priceElement.querySelector('#price-value').textContent = '$--';
                }
            } else {
                priceElement.querySelector('#price-value').textContent = '$--';
            }
        } catch (error) {
            console.error('Failed to update price:', error);
            priceElement.querySelector('#price-value').textContent = '$--';
        }
    }

    /**
     * Get currently selected asset
     */
    getSelectedAsset() {
        return this.selectedAsset;
    }

    /**
     * Set selected asset
     */
    setSelectedAsset(asset) {
        if (this.assets.includes(asset)) {
            this.selectedAsset = asset;
            const dropdown = this.container.querySelector('#asset-dropdown');
            if (dropdown) {
                dropdown.value = asset;
                this.updatePrice();
            }
        }
    }

    /**
     * Cleanup
     */
    destroy() {
        // Cleanup if needed
    }
}

// Export for global access
window.AssetSelector = AssetSelector;
export { AssetSelector };
